export default __webpack_public_path__ + "static/media/toyota-mfa-base.d1939abe.svg";